import RestClient from "@/api/rest.client";
import mapsModule from "@/store/modules/maps.module";
import Select from 'ol-ext/interaction/SelectCluster';
import Popup from 'ol-ext/overlay/Popup';
import PopupStrategyFactory from "./popup.strategy.factory";
export default class PopupService {
    popup: any
    select: any

    init() {
        this.popup = this.createPopup()
        this.select = this.createSelect()
    }

    private createPopup() {
        return new Popup({
            popupClass: "default anim", //"tooltips", "warning" "black" "default", "tips", "shadow",
            closeBox: false,
            positioning: 'bottom-auto',
            offset: [0, -9],
            autoPan: true,
            canFix: true,
            autoPanAnimation: { duration: 100 }
        });
    }

    private createSelect() {
        //TODO: CAMBIAR STYLE AL HACER CLICK EN UNA UNIDAD
        const select = new Select({
            selectCluster: false,
            spiral: true,
            animate: true,
            autoClose: true,
            hitTolerance: 5,
            style: false
            // style: this.createStyleBase2()
        });
        mapsModule.mapService.map.addOverlay(this.popup)
        mapsModule.mapService.map.addInteraction(select)


        select.getFeatures().on(['add'], (item: any) => {
            const feature = item.element
            const type: string = feature.get("type")
            const strategy = new PopupStrategyFactory().create(type, feature)
            if(strategy){
                this.popup.setOffset(strategy.offSet)
                this.popup.show(feature.getGeometry().getCoordinates(), strategy.getContent())
                this.getAddress(strategy.getParamsAddress())
            }
        })

        select.getFeatures().on(['remove'], () => {
            this.popup.hide();
        })
        return select
    }

    private async getAddress(data: { id: string, lat: number, lon: number }, address?: string) {
        const target = data.id
        const result = address || (await RestClient.call({
            params: {
                format: 'json',
                lat: data.lat,
                lon: data.lon,
                addressdetails: 0,
                zoom: 18
            }
        }, process.env.VUE_APP_REVERSE_GEOCODER_URL)).data.display_name
        const element = document?.getElementById(target)
        if (element) element.innerHTML = result || 'NaN'
    }

}